import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Sidebar } from './components/Sidebar';
import { Home } from './pages/Home';
import { Player1 } from './pages/Player1';
import { Player2 } from './pages/Player2';
import { Player3 } from './pages/Player3';
import { Player4 } from './pages/Player4';
import { Player5 } from './pages/Player5';
import { Player6 } from './pages/Player6';
import { Player7 } from './pages/Player7';
import { Player8 } from './pages/Player8';
export function App() {
  return <Router data-id="element-0">
      <div className="flex w-full h-screen" data-id="element-1">
        <Sidebar data-id="element-2" />
        <main className="flex-1 overflow-auto bg-gray-50" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
            <Route path="/player1" element={<Player1 data-id="element-8" />} data-id="element-7" />
            <Route path="/player2" element={<Player2 data-id="element-10" />} data-id="element-9" />
            <Route path="/player3" element={<Player3 data-id="element-12" />} data-id="element-11" />
            <Route path="/player4" element={<Player4 data-id="element-14" />} data-id="element-13" />
            <Route path="/player5" element={<Player5 data-id="element-16" />} data-id="element-15" />
            <Route path="/player6" element={<Player6 data-id="element-18" />} data-id="element-17" />
            <Route path="/player7" element={<Player7 data-id="element-20" />} data-id="element-19" />
            <Route path="/player8" element={<Player8 data-id="element-22" />} data-id="element-21" />
          </Routes>
        </main>
      </div>
    </Router>;
}